<!--忘记密码-->
<template>
  <div class="forgetpass-style">
    <h1 class="login-title">营口房地产交易服务平台</h1>
    <div class="form-style">
      <h2>申请重置密码</h2>
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item prop="userName" label="账号">
          <el-input v-model="form.userName" placeholder="请输入账号"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="passWord" label="密码">
          <el-input
            v-model="form.passWord"
            type="password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="spsd" label="确认密码" label-width="120px">
            <el-input
              v-model="form.spsd"
              type="password"
              placeholder="请确认密码"
            ></el-input>
          </el-form-item> -->
        <el-form-item prop="phone" label="手机号">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <!-- <div class="yzm-style">
          <el-form-item prop="code" label="验证码">
            <el-input v-model="form.code"></el-input>
          </el-form-item>
          <el-button type="primary" @click="getShortMessage">获取验证码</el-button>
        </div> -->
        <div class="yzm-style">
          <el-form-item prop="code" label="验证码">
            <el-input v-model="form.code"></el-input>
          </el-form-item>
          <el-button
            size="small"
            type="primary"
            @click="getShortMessage"
            v-if="times == 0"
            >获取验证码</el-button
          >
          <el-button type="primary" v-else>{{ times }}s后重新发送</el-button>
        </div>
      </el-form>
      <div style="text-align: center; margin-bottom:10px">
        <el-button style="width: 100%" type="primary" @click="nextStep"
          >下一步</el-button
        >
      </div>
      <div>
        <span class="login-btn">
          已有账号？
          <el-button size="small" type="text" @click="goLogin"
            >返回登录</el-button
          >
        </span>
      </div>
    </div>
    <div class="foot-style">
      <div class="foot-cont">
        <div>
          <p>
            <span>电话：0417-3581115 / 0417-3851115</span>
            <span>地址：新联北大街99号</span>
            <span>邮箱：ykdcxxkj@163.com</span>
          </p>
          <p class="xx-bottom">
            <span> 服务支持单位：营口市自然资源事务中心</span>
            <span>主办单位：营口大成信息科技咨询有限公司</span>
            <span>技术支持：营口大成信息科技咨询有限公司</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const checkSpd = (rule,value,callback) =>{
      var data = value + "";
      if(!data){
        callback(new Error('确认密码不能为空'))
      }else if(data != this.form.passWord){
        callback(new Error('两次密码不一致，请输入输入！')) 
      }else{
      callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      let regPone = null;
      let mobile = /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/; // 最新16手机正则
      // let tel = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/; // 座机
      let data = value + "";
      // if (data !== null && data.charAt(0) === "0") {
      //   // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
      //   regPone = tel;
      // } else if (data !== null && data.charAt(0) !== "0") {
      //   regPone = mobile;
      // }
      regPone = mobile;
      if (regPone === null) {
        return callback(new Error("请输入手机号码"));
      } else if (!regPone.test(data)) {
        return callback(
          new Error("请输入正确的手机号码")
        );
      } else {
        callback();
      }
    };
    return {
      times: 0,
      form: {
        phone: "",
        userName:'',
        nickName:"",
        passWord: "",
        spsd:'',
        code: "",
        unitId:4,
        unitName:"个人用户"
      },
      verifCode:"",//后端返回的短信验证码
      rules: {
        userName:[
          {required:true,message:"请输入账号",trigger:"blur"}
        ],
        // passWord:[
        //   {required:true,message:'请输入密码',trigger:'blur'},
        //   {min: 6, message: "密码不得低于6个字符", trigger: "blur" },
        // ],
        // spsd: [
        //   { required: true, validator: checkSpd, trigger: 'blur' },
        //   { min: 6, message: "密码不得低于6个字符", trigger: "blur" },
        // ],
        // nickName:[
        //   {required:true,message:'请输入昵称',trigger:'blur'}
        // ],
        phone:[
          { required: true, validator: checkPhone, trigger: "blur" }
        ],
        code:[
          {required:true,message:"请输入手机验证码",trigger:'blur'}
        ]
      },
    };
  },
  methods: {
    getTime() {
      this.timer = setInterval(() => {
        this.times--;
        if (this.times === 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    getShortMessage(){
      //判断手机号是否录入
      if(this.verifPhone(this.form.phone)){
        var that=this;
        that.axios({
          method:'post',
          url:'/api/shortMessage/getCode',
          data:{
            "phone":that.form.phone
          }
        }).then(res=>{
          if (res.data == "当日发送已达上限") {
              that.$message.error(res.data);
            } else {
              that.times = 60;
              that.getTime();
            }
        })
      }else{
        this.$message.error("请输入正确的手机号码");
      }
    },
    //验证手机号码是否合格
    verifPhone(phone){ 
      let mobile = /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/; // 最新16手机正则
      // let mobile=/^1[1356789]\d{9}$/;
      if (phone === null) {
        return false;
      } else if (!mobile.test(phone)) {
        return false;
      }
      return true;
    },
    //下一步，验证手机号和验证码，返回用户信息以修改密码
    nextStep() {
      var that=this;
      console.log(that.form);
      that.$refs.form.validate((valid) => {
        if (valid) {
          that.axios({
            method:'post',
            url:'/api/grzl/nextStep',
            data:that.form
          }).then(res=>{
            if(res.data.status==0){
              that.$store.commit("setUserData",res.data.data);
              //跳转下一步到修改密码页面
              that.$router.push("/modifyPassword");
              
            }else{
              that.$message.error(res.data.msg);
            }
            
          })

        }
      })
    },
    goLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="less">
.forgetpass-style {
  position: fixed;
  width: 100%;
  height: 100%;
  background-image: url("../assets/login_bg1.jpg");
  background-size: 100%;
  background-repeat: no-repeat;
  .login-title {
    color: #fff;
    margin: 40px 0 0 60px;
    font-size: 34px;
    font-weight: normal;
  }
  .form-style {
    right: 110px;
    padding: 20px 60px;
    width: 468px;
    // height: 400px;
    // height: 560px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 10px;
    color: #5d5d5d;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    h2 {
      text-align: center;
      margin-bottom: 30px;
      font-size: 28px;
    }
    .el-form-item {
      border: 1px solid #c9cacc;
      background: #fff;
      padding-left: 12px;
      margin-bottom: 18px;
      border-radius: 4px;
      .el-input__inner {
        border: 0;
      }
      .el-form-item__label {
        font-size: 16px;
        display: inline-block;
        text-align: justify;
        text-align-last: justify;
      }
    }
    .yzm-style {
      display: flex;
      justify-content: space-between;
      margin-bottom: 18px;
      .el-form-item {
        width: 300px;
        margin-bottom: 0;
      }
    }
    .login-btn {
      font-size: #999;
      margin-left: 28px;
      font-size: 12px;
    }
    .agree-style {
      font-size: 14px;
    }
  }
  .foot-style{
    position: absolute;
    width: 100%;
    bottom: 0;
    padding: 20px 0;
    .foot-cont{
      width: 1200px;
      margin: 0 auto;
      text-align: center;
      font-size: 12px;
      line-height: 30px;
      span{
        margin-right: 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/forgetPassWord.vue